module.exports = __webpack_public_path__ + "media/assets/images/speaker-0bc62ce9e8c9db10a6a2c5a5c4ce86dd.png";